module.exports = __webpack_public_path__ + "static/media/customer.e8d4da1f.svg";